<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        class='font-weight-light'
        v-model='search'
        append-icon='mdi-magnify'
        label='Search adoption type'
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :loading='loading'
      :headers='headers'
      :items='adoptionTypeList'
      :search='search'
      class='elevation-1'
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <p>{{NO_DATA_FOUND}}</p>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    loading: true,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_ADOPTION_TYPE,
    search: '',
    editedIndex: -1,
    // table headers
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'Adoption Type',
        value: 'name',
        sortable: true,
        class: 'title'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: false,
        class: 'title'
      }
    ]
  }),
  computed: {
    // to fetch adoption type list
    adoptionTypeList () {
      return this.$store.getters['AdoptionTypeModule/fetchAdoptionTypeList']
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    // dispatch an action in below method to fetch publishers list
    initialize () {
      // let status = '' // by default status is empty, declare 'status' here for future use
      new Promise((resolve, reject, status) => {
        this.$store.dispatch('AdoptionTypeModule/getAdoptionTypeList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          this.loading = false
        })
        .catch(({ response }) => {
          this.loading = false
        })
    }
  }
}
</script>
